module.exports = __webpack_public_path__ + "img/2_E.8e58b4d3.png";